import { annualReport } from './annual_report';

export const sliceReducers = {
  annualReport,
};
